module.exports = __webpack_public_path__ + "img/1567093173.cfde761d.jpg";